import { Outlet } from 'react-router-dom';

import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary.tsx';
import { ToolkitGenericFallback } from '../components/ToolkitGenericFallback.tsx';

export const ErrorBoundaryLayout = () => (
  <ErrorBoundary Fallback={ToolkitGenericFallback}>
    <Outlet />
  </ErrorBoundary>
);
